import React from "react";
import USQSFormGroup from "./USQSFormGroup";

const QSUSAEcon = () => {
  return (
    <>
      <fieldset>
        <legend>Sales Price</legend>
        <USQSFormGroup labelname={"Sales Price"} inputname={"salesprice"} inputtype={"currency"} />
      </fieldset>
      <fieldset>
        <legend>Economics</legend>
        <USQSFormGroup readOnly labelname={"Profit"} inputname={"profitpmt"} inputtype={"currency"} />
        <USQSFormGroup readOnly labelname={"Margin"} inputname={"profittotal"} inputtype={"currency"} />
        <USQSFormGroup readOnly labelname={"Turnover"} inputname={"turnover"} inputtype={"currency"} />
        <USQSFormGroup readOnly labelname={"% Margin"} inputname={"margin"} inputtype={"percent"} />
        <USQSFormGroup readOnly labelname={"Netback"} inputname={"netback"} inputtype={"currency"} />
      </fieldset>
    </>
  );
};

export default QSUSAEcon;
